<!-- <p>estimate-tab-box works!</p> -->
<div class="box-section">
  <div class="boxWrap">
    <div class="estimate_wrap d_flex align_center">
      <div class="roundedRectangleBox box_1">
        <span class="location_icon"></span>
        <!-- <img src="../../../assets/icons/location_icon.svg" alt="location_pin_icon"> -->
        <span class="address_text textTitle">
          <!-- {{historyState.address}} -->
          <span class="addressl1">{{historyState?.UnitNumber ? historyState.UnitNumber : '' }}
            {{historyState.StreetAddress}} </span><br>{{historyState.City}}, {{historyState.StateOrProvince}}
          {{historyState.PostalCode}}
        </span>
      </div>
      <div class="roundedRectangleBox box_2" *ngIf="historyState.ListPrice">
        <span class="price_icon"></span>
        <!-- <img src="../../../assets/icons/list_price_icon.svg" alt="location_pin_icon"> -->
        <p>
          <span class="textTitle">List Price: </span>
          <span class="contentValue"> ${{historyState.ListPrice | number}}</span>
        </p>
      </div>
    </div>
    <div class="formButtons">
      <button *ngIf="!isLoader" class="submitBtn" (click)="saveButtonClick()">Save</button>
      <button *ngIf="!isLoader" class="arrowBtn leftArrow" (click)="closeButtonOnClick()">
        <span class="close_icon"></span>
        <!-- <img src="../../../assets/icons/close.svg" height="16px" alt="arrow_left"> -->
      </button>

      <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
    </div>


    <!-- mobile scetion -->
    <div class="w_100 mobileDropWrap">
      <div class="responseListItem">
        <div class="roundedRectangleBox">
          <span class="location_icon"></span>
          <!-- <img src="../../../assets/icons/location_icon.svg" alt="location_pin_icon"> -->
          <span class="address_text textTitle">
            <span style="font-weight: 700;">{{historyState?.UnitNumber ? historyState.UnitNumber : '' }}
              {{historyState.StreetAddress}}</span><br> {{historyState.City}}, {{historyState.StateOrProvince}}
            {{historyState.PostalCode}}
          </span>
        </div>
        <div class="roundedRectangleBox" *ngIf="historyState.ListPrice">
          <span class="price_icon"></span>
          <!-- <img src="../../../assets/icons/list_price_icon.svg" alt="location_pin_icon"> -->
          <p>
            <span class="textTitle">List Price: </span>
            <span class="contentValue"> ${{historyState.ListPrice | number}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mobile_submitButtons">
  <div class="action-btn">
    <button *ngIf="!isLoader" class="submitBtn" (click)="saveButtonClick()">Save</button>
    <button *ngIf="!isLoader" class="outline-btn" (click)="closeButtonOnClick()">Close</button>
    <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
  </div>
</div>